<template>
  <div class="account-person-search-panel" :aria-label="$t('commonSearchTitle')">
    <el-form label-position="top" class="account-person-search-panel__form" @submit.prevent>
      <el-form-item class="account-person-search-panel__mode">
        <el-radio-group v-model="localMode" class="account-person-search-panel__mode-group">
          <el-radio value="asan">ASAN</el-radio>
          <el-radio value="manual">Manual</el-radio>
        </el-radio-group>
      </el-form-item>

      <fieldset class="account-person-search-panel__fields" :disabled="isManualMode">
        <el-form-item :label="$t('searchPin')">
          <el-input
            :model-value="pin"
            maxlength="7"
            class="account-person-form__pin-input uppercase-input"
            @update:model-value="$emit('update:pin', $event)"
          />
        </el-form-item>

        <el-form-item class="account-person-form__doc-item" :label="$t('searchDocSeriesNumber')">
          <div class="account-person-form__doc-combo">
            <el-input
              :model-value="docSeries"
              maxlength="3"
              class="account-person-form__doc-series"
              placeholder="AA"
              @update:model-value="$emit('update:docSeries', $event)"
            />
            <span class="account-person-form__doc-divider" aria-hidden="true" />
            <el-input
              :model-value="docNumber"
              class="account-person-form__doc-number"
              :placeholder="$t('commonNumber')"
              @update:model-value="$emit('update:docNumber', $event)"
            />
          </div>
        </el-form-item>

        <div class="account-person-search-panel__actions">
          <el-button
            class="account-person-search-panel__asan-btn"
            type="primary"
            native-type="button"
            :loading="loading"
            :disabled="loading || isManualMode"
            @click.prevent="$emit('search')"
          >
            ASAN
          </el-button>
        </div>
      </fieldset>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "AccountPersonSearchPanel",
  props: {
    pin: { type: String, default: "" },
    docSeries: { type: String, default: "" },
    docNumber: { type: String, default: "" },
    searchMode: { type: String, default: "asan" },
    loading: { type: Boolean, default: false },
  },
  emits: ["update:pin", "update:docSeries", "update:docNumber", "update:searchMode", "search"],
  computed: {
    isManualMode() {
      return this.searchMode === "manual";
    },
    localMode: {
      get() {
        return this.searchMode;
      },
      set(value) {
        this.$emit("update:searchMode", value);
      },
    },
  },
};
</script>

<style scoped>
.uppercase-input :deep(.el-input__inner) {
  text-transform: uppercase;
}
</style>
